import React from 'react'
import styled, { css } from 'styled-components'
import { colors } from '../../styles'
import { TrPlaceholder } from '../TrPlaceholder'

interface IPreviewPicture {
  src: string
  width?: string
  height?: string
  bordered: boolean
}

const StyledPreviewPicture = styled.div.attrs({
  alt: 'Preview',
})<IPreviewPicture>`
  background-image: url('${({ src }) => src}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
  ${({ bordered }) =>
    bordered &&
    css`
      border: 1px solid ${colors.grey10};
    `}
` as React.ComponentType<any>

export const PreviewPicture = (props) =>
  props.src ? (
    <StyledPreviewPicture {...props} />
  ) : (
    <TrPlaceholder size={props.size} bordered />
  )
